

export const stepsList = [
    'Install this pixel into your website ( see the button below )',
    'Start sharing anonymous data, automatically through the pixel',
    'In Q4 2023, connect to the airdrop website. Once you confirm your eligibility, you will get your claim of Web3m tokens straight to your wallet.',
]